import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["id", "aria-labelledby"];
import PropTypes from 'prop-types';
import React, { forwardRef, useContext } from 'react';
import { TabsContext } from '../Tabs/Tabs.context';
import { StyledTabPanel } from './TabPanel.styles';

/**
 * A `Tabs.Panel` is a child of a `Tabs.Panels` component.
 *
 * @since 8.10.0
 */
export var TabPanel = /*#__PURE__*/forwardRef(function (_ref, forwardedRef) {
  var id = _ref.id,
    ariaLabelledby = _ref['aria-labelledby'],
    rest = _objectWithoutProperties(_ref, _excluded);
  var context = useContext(TabsContext);
  var selectedTabId = context.selected || context.selectedState;
  return /*#__PURE__*/React.createElement(StyledTabPanel, _extends({
    "aria-labelledby": ariaLabelledby,
    id: typeof id !== 'undefined' ? id : ariaLabelledby + "_panel",
    hidden: ariaLabelledby !== selectedTabId,
    ref: forwardedRef,
    tabIndex: ariaLabelledby === selectedTabId ? '0' : '-1'
  }, rest));
});
TabPanel.displayName = 'Tabs.Panel';
TabPanel.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * This must match the `id` of the `Tabs.Tab` associated with this panel.
   */
  'aria-labelledby': PropTypes.string.isRequired,
  /**
   * If true, panel is hidden. This prop is automatically set by the component.
   */
  'hidden': PropTypes.bool,
  /**
   * This must match the `aria-controls` of the `Tabs.Tab`
   * associated with this panel.
   *
   * If no `id` is specified, one will automatically be generated.
   */
  'id': PropTypes.string,
  /**
   * This should always be "tabpanel". Defining as a prop solely so we can streamline the
   * `Tabs.Panel` instantiation.
   *
   * @ignore
   */
  'role': PropTypes.string
} : {};
TabPanel.defaultProps = {
  role: 'tabpanel'
};